<template>
  <div class="resource_meta_data">
    <!-- DISPLAY NAME -->
    <div class="form-row">
      <div class="form-group col-12">
        <label :class="isFieldRequired('display_name', formConfig.requiredFields)">
          {{ $t('resource.name.label') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="display_name"
          :rules="`${resource.isNotEmpty() ? isFieldRequired('display_name', formConfig.requiredFields) : ''}|max:100`"
          :name="`Nom ${isMain ? 'ressource' : 'annexe'}`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.name"
              v-sanitize
              class="form-control"
              type="text"
              :data-test="isMain ? 'resource-name-main' : 'resource-name-annexe'"
              :placeholder="isMain ?
                $t('resource.name.resourcePlaceholder') : $t('resource.name.annexPlaceholder')
              "
              @change="ressourceChanged()"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>

    <!-- DESCRIPTION -->
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.description') }}
        </label>
        <textarea
          v-model="resource.description"
          v-sanitize
          class="form-control"
          @change="ressourceChanged()"
        />
      </div>
    </div>

    <div class="form-row">
      <!-- KIND -->
      <div
        v-if="isFieldVisible('kind', formConfig.hiddenFields)"
        class="form-group col-6"
      >
        <label
          :class="resource.isNotEmpty() ? isFieldRequired('kind', formConfig.requiredFields) : ''"
        >
          {{ $t('resource.type.label') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="kind"
          :rules="resource.isNotEmpty() ? isFieldRequired('kind', formConfig.requiredFields) : ''"
          name="Type"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-model="resource.kind"
              :options="resourceKinds"
              :class="classes"
              track-by="id"
              label="display_name"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="false"
              :placeholder="$t('resource.type.placeholder')"
              @select="setKind"
            />
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>

      <!-- LAST UPDATE DATE -->
      <div class="form-group col-6">
        <label
          :class="resource.isNotEmpty() && isMain ? 'required' : ''"
        >
          {{ $t('resource.lastUpdateDate') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="lastUpdateDate"
          :rules="resource.isNotEmpty() && isMain ? 'required' : ''"
          :name="`Date de dernière mise à jour ${isMain ? 'ressource' : 'annexe'}`"
        >
          <div
            class="control"
            :class="isMain ? classes : ''"
          >
            <input
              v-model="resource.lastUpdateDate"
              :class="{ empty: !resource.lastUpdateDate}"
              class="form-control"
              type="date"
              @change="ressourceChanged()"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div
        v-if="isMain"
        class="form-group col-6"
      >
        <label>
          {{ $t('resource.indexation.label') }}
        </label>
        <b-form-select
          id="indexation-type"
          v-model="currentDataset.indexation_type"
          @change="indexationTypeChanged($event)"
          :options="indexationTypes"
          required
          value-field="value"
          text-field="text"
          placeholder="test"
        />
      </div>
      <div
        v-if="isMain && resource && resource.nb_datas !== undefined"
        class="form-group col-6" 
        style="padding-top: 30px;"
      >
        Nombre de données : {{ resource.nb_datas }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import i18n from '@/common/i18n/i18n.js';

import Multiselect from 'vue-multiselect';
import { ErrorService } from '@/services/error-service.js';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
import appAPI from '@/api/modules/app.api.js';
import resourceAPI from '../../../../api/modules/resource.api';
import datasetAPI from '../../../../api/modules/dataset.api';
extend('required', {
  ...required,
  message: i18n.messages[i18n.locale].words.requiredField
});
extend('max', {
  ...max,
  message: i18n.messages[i18n.locale].words.lengthField.replace(/{length}/, '100')
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'ResourceMetaData',

  components: {
    Multiselect,
    ValidationProvider
  },
  indexationTypes:[],
  resourceKinds:[],
  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => {}
    },
    formConfig: {
      type: Object,
      default: () => {
        return {
          hiddenFields: [],
          requiredFields: []
        };
      }
    }
  },

  data() {
    return {
      indexationTypes :this.indexationTypes,
      resourceKinds:this.resourceKinds,
     
    };
  },

  computed: {
    
    ...mapState('datasets', [
      'currentDataset',
    ]),
  },

  watch: {
      
  },

  created() {
    this.resourceKinds=[];
    resourceAPI.getResourceKinds().then((data) => {
      if(data){
        this.resourceKinds = data;
      }
      
    });
    this.indexationTypes=[
      { text: `Complète (${appAPI.settings.ONEGEOSUITE_INDEXER_LIMIT || 5000} données max)`, value: 'full' },
      { text: `Partielle (${appAPI.settings.ONEGEOSUITE_INDEXER_PARTIAL_LIMIT || 5000} données max)`, value: 'partial' },
      { text: 'Pas d\'indexation des données', value: 'none' }];
  },

  methods: {
    setKind(e){
      this.resource.kind=e;
      this.ressourceChanged();
    },
    indexationTypeChanged(value){
      
      const data = {
        indexation_type: value
      };
      datasetAPI.patchDataset(this.currentDataset.id, data);
    
    },
    ressourceChanged(){
      this.resource.dirty=true;
      
      /*if(this.resource.id){
        datasetAPI.updateDatasetResource(this.currentDataset.id, this.resource,false)
          .then(() => {
            ErrorService.onSuccess(
              true,
              `La mise à jour de la ressource <b>${
                this.resource.name ? this.resource.name : ''
              }</b> a été lancée avec succès.<br> Vous devez enregistrer le jeux de données pour que la modification soit appliquée`
            );   
          })
          .catch((err) => {
            console.error(err);
          });
      } */ 
    }
   
  }
};
</script>
